import * as React from "react";
import { useReducer } from "react";
import { Input, Button, Checkbox, message, DatePicker } from "antd";
import styled from "styled-components";
import { conference as confapi } from "@/api";
import { Action, reducer, initialState } from '@/Action';
import { BoolType, ConferenceInterface } from "@/types";
import { useAuth } from "@/component/Auth";
import moment from "moment";
import { time } from "@/util";
import { manageModify } from "@/api/conference";

const Container = styled.div`
  .atitle {
    height: 40px;
    font-size: 18px;
    font-weight: 500;
    color: #999;
  }
`;

interface ManageEditProp {
  conference: ConferenceInterface;
  onClose: () => void;
  editFinish: () => void;
}

const ManageEdit: React.FC<ManageEditProp> = ({
  conference,
  onClose,
  editFinish,
}) => {
   
  const [state, dispatch] = useReducer(reducer, initialState);
  const auth = useAuth();
  const { loginfo } = auth;

  const [title, setTitle] = React.useState(conference.title);
  const [beginTime, setBeginTime] = React.useState(
    moment(conference.beginTime)
  );
  const [endTime, setEndTime] = React.useState(
    moment(conference.endTime)
  );
  const [passwordEnable, setPasswordEnable] = React.useState(
    conference.passwordEnable
  );
  const [password, setPassword] = React.useState(conference.password);
  const [ownerPassword, setOwnerPassword] = React.useState(
    conference.ownerPassword
  );
  const [allowEarlyEntry, setAllowEarlyEntry] = React.useState(
    conference.allowEarlyEntry
  );
  const [muteJoinMeeting, setMuteJoinMeeting] = React.useState(
    conference.muteJoinMeeting
  );
  const [allowSelfUnmute, setAllowSelfUnmute] = React.useState(
    conference.allowSelfUnmute
  );
  const [playTips, setplayTips] = React.useState(conference.playTips);

  //设法获取 conference 是否静音属性
  const updateConference = async () => {
     
    console.log('conference allowSelfUnmute::::', allowSelfUnmute)
    console.log('conference allowSelfUnmute::::',  conference.allowSelfUnmute)
    await manageModify({
      title,
      beginTime: time.format(beginTime),
      endTime: time.format(endTime),
      allowEarlyEntry,
      muteJoinMeeting,
      playTips,
      allowSelfUnmute,
      passwordEnable,
      conferenceNo: loginfo.conferenceNo,
      password,
      ownerPassword,
      conferenceId: conference.conferenceNo,
    });
    message.success("会议更新成功！");
    editFinish();
  };

  const titleChange = (e: any) => setTitle(e.target.value);

  const handlePasswordChange = (val: string) => {
    val = val.replace(/[^\d]/g, '');
    setPassword(val);
  }

  return !!conference ? (
    <div
      className="modal f jc"
      
      // onCancel={onClose}
      // visible={!!conference}
      // centered
      // width={450}
    >
      <Container className="w280">
        <div className="atitle jsc mt30">修改会议</div>
        <div className="mt20">
          <Input
            placeholder="请输入会议主题"
            onChange={titleChange}
            value={title}
          />
        </div>
        <div className="mt15">
          {/* <DatePicker
            value={beginTime}
            showTime
            onChange={setBeginTime}
            placeholder="会议开始时间"
          />
          <DatePicker
            value={endTime}
            showTime
            onChange={setEndTime}
            placeholder="会议结束时间"
          /> */}
        </div>
        <div className="mt15">
          <Checkbox
            checked={passwordEnable === BoolType.yes}
            onChange={(e) =>
              setPasswordEnable(e.target.checked ? BoolType.yes : BoolType.no)
            }
          >
            设置会议密码
          </Checkbox>
        </div>
        {passwordEnable === BoolType.yes && (
          <div className="mt15">
            <Input
              style={{ width: 280 }}
              placeholder="请输入会议密码"
              value={password}
              onChange={(e) => handlePasswordChange(e.target.value)}
            />
          </div>
        )}
        <div className="mt15">
          {/* <Input
            placeholder="请输入主持人密码"
            value={ownerPassword}
            onChange={(e) => setOwnerPassword(e.target.value)}
          /> */}
        </div>
        {/* <div className="mt15">
          <Checkbox
            checked={allowEarlyEntry === BoolType.yes}
            onChange={(e) =>
              setAllowEarlyEntry(e.target.checked ? BoolType.yes : BoolType.no)
            }
          >
            允许成员在主持人进入会前加入会议
          </Checkbox>
        </div> */}
        <div className="mt15">
          <Checkbox
            checked={muteJoinMeeting === BoolType.yes}
            onChange={(e) =>
              setMuteJoinMeeting(e.target.checked ? BoolType.yes : BoolType.no)
            }
          >
            会员入会时静音
          </Checkbox>
        </div>
        <div className="mt15">
          <Checkbox
            checked={allowSelfUnmute === BoolType.yes}
            onChange={(e) =>{
              
              let tempv=e.target.checked ? BoolType.yes : BoolType.no
              console.log("setAllowSelfUnmute:::", tempv)
              setAllowSelfUnmute(tempv)
            }
             
            }
          >
            允许成员自我解除静音
          </Checkbox>
        </div>
        <div className="mt15">
          <Checkbox
            checked={playTips === BoolType.yes}
            onChange={(e) =>{
              setplayTips(e.target.checked ? BoolType.yes : BoolType.no)
              dispatch({ type: 'SetPlayTips', payload: playTips });
            }
             
              
            }
          >
            成员加入会议时播放提示音
          </Checkbox>
        </div>
        <div className="mt30 jssb">
          <Button className="w120" onClick={onClose}>
            取消
          </Button>
          <Button className="w120" type="primary" onClick={updateConference}>
            修改
          </Button>
        </div>
      </Container>
    </div>
  ) : (
    <></>
  );
};

export default ManageEdit;
